export default {
  simplify_game: 'You build the game, we power the backend',
  ingame_desc:
    'InGame is a fully-hosted backend platform designed to enpower developers to build world-class games with cost-effeciency.',
  start_for_free: 'Start For Free',
  about_ingame: 'About InGame',
  our_services: 'SERVICES',
  out_of_box:
    'More than 20 out-of-the-box backend services, unleasing your creativity',
  out_of_box_one: '20+ ready-to-use backend services',
  out_of_box_two: 'Unleash your creativity now',
  multiplayer_desc: 'Crafting dynamic multiplayer online gaming experiences',
  economy_desc: 'Building long-term operational ecosystems',
  content_desc: 'Empowering global game content distribution across platforms',
  analytics_desc:
    'Enabling data-informed game operations through mature analytics systems and real-time performance insights',
  engage_desc: 'Driving player engagement and rentention',
  social_desc: 'Enabling player interations across platfroms with ease',
  maximizing_your_reach: 'Cross-platform - Engine agnostic',
  our_benifits: 'KEY BENEFITS',
  how_developers: 'What we bring to the table',
  streamlined_efficiency: 'Streamlined Efficiency',
  rapid_development: 'Rapid Development',
  rapid_development_desc:
    'Provides Cloud-based development environment,supports plugin-based integration and multi-platform compatibility.',
  effortless_maintanance: 'Low Maintanance',
  effortless_maintanance_desc:
    'Fully hosted backend services with 24/7 system monitoring.',
  effortless_maintanance_desc_two:
    'Support for  multi-cloud deployment, massive concurrent users, automated fault recovery, and zero-downtime elastic scaling.',
  advanced_operations: 'Advanced Operations',
  advanced_operations_desc:
    'Comprehensive data analytics and engagements to support game operations.',
  enterprise_grade: 'Enterprise-Grade Reliability',
  high_availability: 'High Availability',
  high_availability_desc:
    'Distributed architecture with automatic fault recovery.',
  high_scalability: 'High Scalability',
  high_scalability_desc:
    'Seamless elastic scaling to dynamically adjust resources.',
  high_performance: 'High Performance',
  high_performance_desc:
    'Supports large-scale concurrency and millisecond response times.',
  battle_tested: 'Battle-tested Architecture',
  battle_tested_desc:
    'The underlying architecture has been validated by numerous Tencent Games.',
  unlimited_flexibility: 'Unlimited Flexibility',
  cross_cloud: 'Cross-cloud Communication',
  cross_cloud_desc: 'Compatible with AWS, Azure, Tencent Cloud.',
  muilt_region: 'Muilt-Region Deployment',
  muilt_region_desc: 'Cross-continent communication between services.',
  microservice_customization: 'Microservice Customization',
  microservice_customization_desc:
    'Microservices architecture supporting custom game logic.',
  global_service: 'GLOBAL INFRASTRUCTURE',
  global_support_tips: 'Build with global success in mind',
  service_deployment: 'Service',
  service_deployment_desc:
    'Reduction of network latency with multi-regional access points.',
  game_server_deployment: 'Server Locations:',
  cn_shanghai: 'China - Shanghai',
  na_virginia: 'NA - Virginia',
  eu_frankfurt: 'EU - Frankfurt',
  ap_singapore: 'APAC - SEA; Singapore',
  dediacated_server_deployment: 'DS locations:',
  deployed_globally: '55+ locations available',
  global_team_support: 'Support',
  global_team_support_desc:
    'With teams in UK, North America, SEA and China, we provide solution consulation and technical support around the clock. ',
  multi_country: 'Compliance',
  multi_country_desc:
    'Fully compliant with various data privacy regulations. We offer local data storage and processing solutions to ensure player infomation safety. ',
  multilingual_support: 'Bilingual Support',
  multilingual_support_desc:
    'Independent domains for Chinese and international users, with content and product materials available in both Chinese and English, facilitating global team collaborations.',
  parnter_showcase: 'PARTNERS',
  parnter_showcase_desc: 'Trusted by leading development studios',
  security_assurance: 'SECURITY ASSURANCE',
  security_statement: 'Security Statement',
  security_statement_desc:
    'InGame follows the highest standard of information security and privacy protection, and is committed to safeguarding information systems, intellectual property, and customer data from misuse or compromise.',
  new_get_started: 'GETTING STARTED',
  enter_email_address: 'E-mail',
  cost_effcient_development: 'Cost-Effcient Development',
  cost_effcient_development_desc:
    'Rapidly build game backends through plugin-based service integration with customizable microservices extensions.',
  data_driven_operation: 'Data-driven Operation',
  data_driven_operation_desc:
    'Provide Comprehensive data analytics and engagement services to support game operations, helping developers to understand players and react to player behavior.',
  enter_wecom_name: 'WeCom Name',
  ready_to_try: 'Ready to give it a try?',
  start_for_free_new: 'Start for free',
  find_out_more: 'Find out more',
};
